/*

File handles all api calls for Spaces


*/
import { server } from '../engine/server'
import { modal } from '../utilities/modal'
import { levelRenderer } from '../graphic_engine/controllers/LevelRenderer'

import update from 'immutability-helper';

var Spaces = Class.create({
	// #  Eventually have class update spaceID after update
	uuid: null,
	levelHandler: null,
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
	},
	getSpace: function(uuid, context, isHandler = null) {
		this.uuid = uuid;
		if(isHandler != null) {
			this.levelHandler = isHandler;
		}
		var self = this;

		var url = "spaces/" + uuid;
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
            
            if(response.data[0].data != false) {
                response.data[0].data['meta_data'] = response.data[0].meta_data;
			}

			var data = {
				"space_data": response.data[0].data,
				"contract_data": response.data[0].contract_data,
				"tenant_data": response.data[0].tenant_data,
				"uuid": response.data[0].uuid
			};

        	context.setState({
                taskData: data,
				triggerMultiTask: true,
				reloadData: true
			});

			if(self.levelHandler != null) {
				var colorHex = response.data[0].data.color_hex_code;
				self.levelHandler.reloadSpace(response.data[0].data.uuid, colorHex);
			}
		})
		.fail(function(e){
			console.log(e);
		});
	},
	/**
	*
	* Retrieves all spaces related to user
	*
	*/
	getSpaces: function(context) {
		// #  Localize this instance for use on success
		var self = this;

		var url = "spaces/";
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
            context.setState({
                data: response.data
            })
		})
		.fail(function(e){
			console.log(e);
		});
	},
	getSpacesBasedOnBuilding: function(buildingId, context) {
		var self = this;
		if(buildingId === undefined || !buildingId){
			return;
		}

		var url = "spaces/building/" + buildingId;
		var data = this.server.getData(url,null,false);
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}

			context.setState({
                data: response.data
			});
		})
		.fail(function(e){
			console.log(e);
		});
	},
    /**
	*
	* Saves space details
	*
	*/
	saveSpaceDetails: function(context) {
		var self = this;
		// prepare our data to be sent
		var url = "spaces/" + context.state.spaceDetails.spaceDataID;
		var params = context.state.spaceDetails;
		// Attach uuid to request
		params['uuid'] = self.uuid;
		params['sensorUuid'] = context.state.sensorUuid;
		params['sensorIdentifier'] = context.state.sensorIdentifier;
		// #  Send to server object for processing
		var data = this.server.getData(url, params, false, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				// check to see if we actually moved someone in
				var alreadyMovedIn = true;
				var assignedLease = true;
				if(response.data.tenant_id == 0) {
					alreadyMovedIn = false;
				}

				if(response.data.contract_id == "0") {
					assignedLease = false;
				}

                context.setState({
					lastUpdated: response.data.last_updated,
					getDataAgain: true,
					spaceDetails: update(context.state.spaceDetails, {
						spaceDataID: {$set: response.data.space_data_id},
						alreadyMovedIn: {$set: alreadyMovedIn},
						assignedLease: {$set: assignedLease},
						uuid: {$set: self.uuid}
					})
                });
                modal.showInfo("Space " + context.state.spaceDetails.taskTitle + " was sccuessfully updated.", "success", "top", "center");
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	/*
	*	Saves space data added to graphical engine
	*
	*/
	saveSpace: function(spaceData, callback) {
		var self = this;
		// prepare our data to be sent
		var url = "spaces";
		var params = spaceData;
		// #  Send to server object for processing
		var data = this.server.getData(url,params, true, "POST");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				modal.showInfo("New space was sccuessfully added.", "success", "top", "center");
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	/**
	*
	* Removes space details
	*
	*/
	removeSpaceDetails: function(context) {
		var self = this;
		// #  Send out success message
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this spaces data.  All associated data will be deleted and you will not be able to recover.","Yes, Delete");
		// #  Bind okay button
		jQuery(".move-on").on('click',function() {
			// prepare our data to be sent
			var url = "spaces/" + context.state.spaceDetails.spaceDataID;
			var params = context.state.spaceDetails;
			// #  Send to server object for processing
			var data = self.server.getData(url,params,false, "DELETE");
			// #  Listen to our data
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					modal.showInfo("All data associated with space " + context.state.spaceDetails.taskTitle + " has been removed.", "success", "top", "center");
					levelRenderer.reloadSpaceVersionTwo(context.state.spaceDetails.uuid, undefined, false)

					context.setState({
						spaceDetails: {
							taskTitle: "",
							spaceDataID: 0,
							alreadyMovedIn: false
						},
						lastUpdated: ""
					});

				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like something went wrong", "danger", "top", "center");
			});
		});
	},
	disableAlarm: function(context) {
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","You are about to disable this alarm.","Yes, Disable");
		jQuery(".move-on").on('click',function() {
			var url = "hardware/sensor/" + context.state.sensorUuid;
			const params = context.state;
			var data = self.server.getData(url, params, false, "PUT");
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					modal.showInfo("Alarm has been disabled.", "success", "top", "center");
					levelRenderer.reloadSpaceVersionTwo(context.state.spaceDetails.uuid, undefined, false)

					context.setState({
						sensorActive: 0
					});

					levelRenderer.disableSensor(context.state.spaceDetails.uuid);
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like something went wrong", "danger", "top", "center");
			});
		});
	},
	removeSpaceDetailsAnd3DBuild: function(context) {
		var self = this;
		// #  Send out success message
		modal.showDangerModalWithOK("Are you sure?","You are about to delete this 3D space.  All associated data will be deleted and you will not be able to recover.","Yes, Delete");
		// #  Bind okay button
		jQuery(".move-on").on('click',function() {
			// prepare our data to be sent
			var url = "spaces/" + context.state.spaceDetails.spaceDataID + "/build";
			var params = context.state.spaceDetails;
			// #  Send to server object for processing
			var data = self.server.getData(url,params,false, "DELETE");
			// #  Listen to our data
			data
			.done(function(response){
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					modal.showInfo("All data associated with space " + context.state.spaceDetails.taskTitle + " has been removed.", "success", "top", "center");
					levelRenderer.removeSpace(context.state.spaceDetails.uuid)
					context.props.closeTask();
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like something went wrong", "danger", "top", "center");
			});
		});
	},
	/**
	 * Moves out a tenant associated with space
	 */
	moveOut: function(context) {
		var self = this;
		// #  Send out success message
		modal.showDangerModalWithOK("Are you sure?","You are about to move this tenant out.","Yes, Move Out");
		// #  Bind okay button
		jQuery(".move-on").on('click',function() {
			// prepare our data to be sent
			var url = "leases/moveout/" + context.state.contractData.contract_id;
			// #  Send to server object for processing
			var data = self.server.getData(url, null, false, "PUT");
			// #  Listen to our data
			data
			.done(function(response){
				// #  Validate response
				if(response.data.error_user_authentication == 1)
				{
				}
				else if(response.data.error || (response.status == 1 || response.status == 2))
				{
				} else {
					modal.showInfo("Space " + context.state.spaceDetails.taskTitle + " had a tenant move out.", "success", "top", "center");
					context.setState({
						lastUpdated: response.data.last_updated,
						getDataAgain: true,
						spaceDetails: update(context.state.spaceDetails, {
							alreadyMovedIn: {$set: false}
						})
					});
				}
			})
			.fail(function(e){
				modal.showInfo("Oops! Looks like something went wrong", "danger", "top", "center");
			});
		});
	}
});

export let spaces = new Spaces();


// WEBPACK FOOTER //
// app/core/controllers/Spaces.js